(function ($) {
    window.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    };

    window.getEnvironment = function () {
        if (location.href.indexOf("csstg") > 0)
            return ".csstg";

        if (location.href.indexOf("stg") > 0)
            return ".csuat";

        if (location.href.indexOf("csdev") > 0)
            return ".csdev";

        return "";
    };

    window.getJoinUrl = function () {
        return "http://member.carsalesnetwork" + getEnvironment() + ".com.au/access/carsales/join";
    };

    window.getSignInUrl = function () {
        return "http://member.carsalesnetwork" + getEnvironment() + ".com.au/access/carsales/signin";
    };

    window.getJoinHtml = function () {
        return '<a class="append-return-url" data-tracking="WT.Z_SignInSrc=Bubble" href="' + getJoinUrl() + '"><span class=qtip-content-highlight>Join</span></a>';
    };

    window.getSignInHtml = function () {
        return '<a class="append-return-url" data-tracking="WT.Z_JoinSrc=Bubble" href="' + getSignInUrl() + '"><span class=qtip-content-highlight>Sign-in</span></a>';
    };

    window.getMemberName = function () {
        var memberdata = window.getCookie(".CsnTRC");
        if (memberdata.length > 0) {
            return JSON.parse(atob(memberdata)).Name;
        }

        return "";
    };

    window.canDisplayWelcomeBackMsgs = function () {
        if (window.getCookie(".CsnTRCOut").length == 0) {
            return false;
        }

        var justSignOut = window.getCookie(".CsnSignOut").length > 0;
        if (justSignOut) {
            return false;
        }

        return true;
    };
}(jQuery));